@if (links?.length > 2 && !isDevice) {
  <sd-anchor-bloc
    class="c__anchor-nav"
    [ngClass]="{ 'is-sticky': isSticky }"
    [isOpened]="isOpened"
    [links]="links"
    (linkClicked)="linkClicked($event)"
    (isOpenedChange)="menuHasChanged($event)"
  />
}
